import React from 'react';
import packageInfo from '../../../../package.json';
import flag from '../../../images/flag.svg';
import imed from '../../../images/logo.png';

import './index.scss';

function Footer() {
  return (
    <footer>
      <div className="bg-white shadow-sm py-4">
        <div className="container">
          <div className="row h-100">
            <div className="col-12 col-md-6 media d-flex align-items-center">
              <img src={flag} alt="bandera Chile" />
              <div className="media-body">
                <div>
                  <span className="caption text-graydark ml-3"> Chile</span>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-6 d-flex justify-content-end align-items-center">
              <div className="location mr-4">
                <span className="caption text-graydark">
                  {new Date().getFullYear().toString()}
                  {' '}
                  Derechos Reservados | Imed S.A. | v&nbsp;
                  {packageInfo.version}
                </span>
              </div>
              <img src={imed} className="logo-footer" alt="logo imed" />
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
export default Footer;
